import React from "react";

const SelectComponent = ({ label, secondLabel, name, options, required, value, handleChange , disabled}) => {
  return (
    <>
      <div className="mx-2 my-1">
       
        <label
          htmlFor="countries"
          className=" mb-1 mb-sm-1 mb-md-1 mb-lg-1 text-sm font-medium text-semibold"
          style={{ color:'#a7a7a7'}}
        >
          {label}
        </label>
       
        
        
        <select
          value={value}
          required={required}
          name={name}
          onChange={(e) => {
            handleChange(e)
          }}
          disabled={disabled}
          style={{
            backgroundColor: "rgb(15 33 46)",
            border: "1px solid rgb(47 69 83)",
            color:'#a7a7a7'
          }}
          className="bg-gray-50 border border-gray-300 text-sm rounded w-full p-2 dark "
        >
          <option selected style={{ color:'#a7a7a7'}}>Choose {label}</option>
          {options?.map((itm, index) => {
            return (
              <option key={index} value={itm?.value} style={{ color:'#a7a7a7'}}>
                {itm?.label}
              </option>
            );
          })}
        </select>
      </div>
    </>
  );
};

export default SelectComponent;
